import React from 'react';
import Submenu from "../shared/Submenu.js";

export default function SensorDetailSubmenu({ SensorId }){
  return (
    <Submenu items={[
      { to: `/sensors/${SensorId}`, label: 'Resumen', end: true },
      { to: `/sensors/${SensorId}/model3d`, label: 'Modelo 3D', features: ['DETAIL_SENSOR_3D'] },
    ]}/>
  )
}
